export enum FixedMonthlyFeeType {
  Integral = "I",
  MinimumConsumption = "C",
}
